<script>
    import IntersectionObserver from "svelte-intersection-observer";

    let element;
    let intersecting;

    export let elHeight = 100;
    export let elWidth = 100;

    let maxHeight = 0;

    $: maxHeight = elHeight > maxHeight ? elHeight : maxHeight;
</script>


<IntersectionObserver {element} bind:intersecting>
    <div bind:this={element}>
        {#if intersecting}
        <div bind:clientWidth={elWidth} bind:clientHeight={elHeight} style="min-height: {maxHeight}px">
            <slot></slot>
        </div>
        {:else}
        <div class="placeholder" style="height: {elHeight}px; {elWidth > 0 ? 'width: ' + elWidth + 'px' : ''}">
            Loading...
        </div>
        {/if}
    </div>
</IntersectionObserver>
